// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1C4kP","content":"LoadingAlert_content__3NQ6L"};